import { faq as faqEn } from './en/faq.locale';
import { faq as faqVi } from './vi/faq.locale';
import { faq as faqRu } from './ru/faq.locale';
import { faq as faqKo } from './ko/faq.locale';
import { faq as faqJp } from './jp/faq.locale';
import { faq as faqZh } from './zh/faq.locale';
export const faqLocale = {
    en: {
        faq: faqEn,
    },
    vi: {
        faq: faqVi,
    },
    jp: {
        faq: faqJp,
    },
    ru: {
        faq: faqRu,
    },
    ko: {
        faq: faqKo,
    },
    zh: {
        faq: faqZh,
    },

};
